import React from 'react';
import styles from './Button.module.css';
import { motion } from 'framer-motion';

export const ProjectButton = (props) => {
  const goTo = () => {
    props.event.preventDefault();
  };
  return (
    <motion.button
      whileHover={{ scale: 1.2 }}
      animate={{ y: -60 }}
      className={styles.buttom_project}
      onClick={goTo}
    >
      {props.children}
    </motion.button>
  );
};

export default ProjectButton;
